const variables = {
  media: {
    xs: 'screen and (min-width: 0px)',
    sm: 'screen and (min-width: 48em)',
    md: 'screen and (min-width: 62em)',
    lg: 'screen and (min-width: 64em)',
    xl: 'screen and (min-width: 80em)',
  },

  fonts: {
    body: '\'Source Sans Pro\', serif',
    header: '\'Space Mono\', Courier, sans-serif',
  },

  // Main color name (medium) has been taken from: http://chir.ag/projects/name-that-color/
  colors: {
    jade: {
      darker: '#004121',
      dark: '#007e44',
      medium: '#00b06a',
      light: '#57d684',
      lighter: '#b0f1b5',
    },
    carnationPink: {
      darker: '#332721',
      dark: '#996467',
      medium: '#ffa9d3',
      light: '#ffcbd8',
      lighter: '#ffeff0',
    },
    silverTree: {
      darker: '#205341',
      dark: '#3f896e',
      medium: '#64b99a',
      light: '#88debf',
      lighter: '#baf5e0',
    },
    sunsetOrange: {
      darker: '#690a01',
      dark: '#b42515',
      medium: '#fd4f39',
      light: '#ffa273',
      lighter: '#ffe9cb',
    },
    bondiBlue: {
      darker: '#001526',
      dark: '#006a6d',
      medium: '#00a9b0',
      light: '#6ad7c6',
      lighter: '#d6f2f5',
    },
    pearlBrush: {
      darker: '#302e2c',
      dark: '#8d847f',
      medium: '#e7dbd3',
      light: '#f5f1e6',
      lighter: '#ffffff',
    },
    azureRadiance: {
      darker: '#013d7a',
      dark: '#015abe',
      medium: '#0077ff',
      light: '#65b2ff',
      lighter: '#c9e7ff',
    },
    eunry: {
      darker: '#563b3e',
      dark: '#926b71',
      medium: '#cb9ea5',
      light: '#e4b6bd',
      lighter: '#f5d5da',
    },
    oracle: {
      darker: '#00282f',
      dark: '#004548',
      medium: '#357972',
      light: '#a1c9b7',
      lighter: '#c5e4c7',
    },
  },

  headerFontFamily: [
    'Aito Mono',
    'Space Mono',
    'Courier',
    'sans-serif',
  ]
}

export default variables
